const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

const contractMgtRouter = {
  path: '/intermodality',
  component: index,
  children: [
    {
      path: 'customerContract',
      name: 'customerContract',
      component: () => import('@/pages/intermodality/contract/overview/CustomerContract.vue'),
      meta: {
        keepAlive: true,
        title: '客户合同列表',
      },
    },
    {
      path: 'customerContractDetail',
      name: 'customerContractDetail',
      component: () => import('@/pages/intermodality/contract/detail/customerContractDetail.vue'),
      meta: {
        keepAlive: true,
        title: '客户合同详情',
      },
    },
    {
      path: 'customerContractCreation',
      name: 'customerContractCreation',
      component: () => import('@/pages/intermodality/contract/detail/customerContractCreation.vue'),
      meta: {
        keepAlive: true,
        title: '客户合同新建',
      },
    },
    {
      path: 'customerContractCopy',
      name: 'customerContractCopy',
      component: () => import('@/pages/intermodality/contract/detail/customerContractCopy.vue'),
      meta: {
        keepAlive: true,
        title: '客户合同续签',
      },
    },
    {
      path: 'customerContractHistoryDetail',
      name: 'customerContractHistoryDetail',
      component: () =>
        import('@/pages/intermodality/contract/detail/customerContractHistoryDetail.vue'),
      meta: {
        keepAlive: true,
        title: '客户合同历史',
      },
    },
    {
      path: 'supplierContract',
      name: 'supplierContract',
      component: () => import('@/pages/intermodality/contract/overview/SupplierContract.vue'),
      meta: {
        keepAlive: true,
        title: '供方合同列表',
      },
    },
    {
      path: 'supplierContractDetail',
      name: 'supplierContractDetail',
      component: () => import('@/pages/intermodality/contract/detail/supplierContractDetail.vue'),
      meta: {
        keepAlive: true,
        title: '供方合同详情',
      },
    },
    {
      path: 'supplierContractHistoryDetail',
      name: 'supplierContractHistoryDetail',
      component: () =>
        import('@/pages/intermodality/contract/detail/supplierContractHistoryDetail.vue'),
      meta: {
        keepAlive: true,
        title: '供方合同历史',
      },
    },
    {
      path: 'supplierContractCreation',
      name: 'supplierContractCreation',
      component: () => import('@/pages/intermodality/contract/detail/supplierContractCreation.vue'),
      meta: {
        keepAlive: true,
        title: '供方合同新建',
      },
    },
    {
      path: 'supplierContractCopy',
      name: 'supplierContractCopy',
      component: () => import('@/pages/intermodality/contract/detail/supplierContractCopy.vue'),
      meta: {
        keepAlive: true,
        title: '供方合同复制',
      },
    },
    {
      path: 'supplierContractRenew',
      name: 'supplierContractRenew',
      component: () => import('@/pages/intermodality/contract/detail/supplierContractRenew.vue'),
      meta: {
        keepAlive: true,
        title: '供方合同续签',
      },
    },
    {
      path: 'otherContract',
      name: 'otherContract',
      component: () => import('@/pages/intermodality/otherContract/overview/index.vue'),
      meta: {
        keepAlive: true,
        title: '其他合同列表',
      },
    },
    {
      path: 'otherContractCreation',
      name: 'otherContractCreation',
      component: () =>
        import('@/pages/intermodality/otherContract/detail/otherContractCreation.vue'),
      meta: {
        keepAlive: true,
        title: '其他合同新建',
      },
    },
    {
      path: 'otherContractCopy',
      name: 'otherContractCopy',
      component: () => import('@/pages/intermodality/otherContract/detail/otherContractCopy.vue'),
      meta: {
        keepAlive: true,
        title: '其他合同复制',
      },
    },
    {
      path: 'otherContractDetail',
      name: 'otherContractDetail',
      component: () => import('@/pages/intermodality/otherContract/detail/otherContractDetail.vue'),
      meta: {
        keepAlive: true,
        title: '其他合同详情',
      },
    },
    {
      path: 'otherContractHistoryDetail',
      name: 'otherContractHistoryDetail',
      component: () =>
        import('@/pages/intermodality/otherContract/detail/otherContractHistoryDetail.vue'),
      meta: {
        keepAlive: true,
        title: '其他合同历史',
      },
    },
  ],
};

export default contractMgtRouter;
